import { Directive, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PanelStatus } from 'app/modules/florder/florder-edit-container/florder-edit.interface';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ValidatorService } from 'app/core/services/validator.service';
import { ScrollService } from 'app/core/services/scroll.service';
import { Destroyable } from 'app/core/util/destroyable';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';

@Directive()
export abstract class FlorderEditPlanningComponent<T extends PanelStatus = PanelStatus> extends Destroyable implements OnInit, OnChanges {
  @Input() panelStatus: T;
  @Output() nextClicked = new EventEmitter<any>();
  @Output() cancelClicked = new EventEmitter<void>(); // Go back to orders-list
  @Output() backClicked = new EventEmitter<void>();
  @Output() formValidChanged = new EventEmitter<boolean>();

  editFlorderPlanningForm: UntypedFormGroup;
  private editStatus = new BehaviorSubject<boolean>(false);

  constructor(protected formBuilder: UntypedFormBuilder, protected validatorService: ValidatorService, protected scrollService: ScrollService) {
    super();
    this.editStatus
      .asObservable()
      .pipe(
        takeUntil(this.destroyed$),
        distinctUntilChanged(),
        filter(isEdit => isEdit)
      )
      .subscribe(() => {
        this.scrollService.scrollToElement('step-planning');
      });
  }

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.panelStatus) {
      if (this.panelStatus) {
        this.editStatus.next(this.panelStatus.isEdit);
      } else {
        this.editStatus.next(false);
      }
    }
  }

  abstract createForm();

  isValidForm(): boolean {
    return !this.editFlorderPlanningForm.invalid;
  }
}
